import type { IconSvgObject } from './types';

const CssThreeIcon: IconSvgObject = [
  ["path", { d: "M20.5 2.5H3.5L5.5 19.5L11.5 21.5L18.5 19.5L20.5 2.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7.5 6.5H16.5L8 11H16L15.5 16L12 17L8.5 16L8.3 14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CssThreeIcon;
